const sections = [
  {
    title: "1. VENDOR TERMS & CONDITIONS",
    paragraphs: [
      "Each vendor operates under their own Terms and Conditions.",
      "Should the Client cancel or breach any vendor agreement:",
    ],
    bullets: [
      "The vendor's cancellation policy will apply.",
      "The Event Planner holds no responsibility for vendor refunds.",
      "The Event Planner is not obligated to refund any payments made to vendors if the Client breaches vendor contracts.",
    ],
  },
  {
    title: "2. CANCELLATION POLICY (EVENT PLANNER SERVICES)",
    paragraphs: ["2.1 Cancellation must be submitted in writing.", "2.2 If cancellation occurs:"],
    bullets: [
      "3 months or more before the event date: The Client will receive a refund of payments made, less the non-refundable service fee.",
      "Less than 3 months before the event date: No refund will be issued for planning services rendered.",
      "Deposits are non-refundable once planning has commenced.",
    ],
  },
  {
    title: "3. LIMITATION OF LIABILITY",
    paragraphs: ["The Event Planner:"],
    bullets: [
      "Acts as a coordinator between Client and vendors.",
      "Is not liable for vendor performance failures, delays, damages, or cancellations.",
      "Is not responsible for unforeseen circumstances such as weather, load shedding, force majeure events, or government restrictions.",
    ],
  },
  {
    title: "4. CLIENT RESPONSIBILITIES",
    paragraphs: ["The Client agrees to:"],
    bullets: [
      "Provide clear instructions and approvals timeously.",
      "Make all required payments by agreed deadlines.",
      "Communicate any changes in writing.",
      "Respect vendor contractual obligations.",
    ],
  },
  {
    title: "5. FORCE MAJEURE",
    paragraphs: [
      "The Event Planner shall not be held liable for circumstances beyond reasonable control including but not limited to natural disasters, government restrictions, pandemics, civil unrest, or acts of God.",
    ],
  },
  {
    title: "6. ENTIRE AGREEMENT",
    paragraphs: [
      "This Agreement constitutes the full understanding between both parties and supersedes all prior discussions.",
    ],
  },
  {
    title: "7. PAYMENT REFERENCE CLAUSE",
    paragraphs: [
      "All payments made by the Client must reflect the agreed reference number or event name provided by the Event Planner.",
      "Proof of payment must be sent to the Event Planner within 24 hours of transfer.",
      "The Event Planner shall not be held liable for delays in planning, vendor bookings, or confirmations resulting from payments made without the correct reference or without proof of payment.",
      "No services will commence without confirmed receipt of cleared funds.",
    ],
  },
  {
    title: "8. MARKETING & PHOTOGRAPHY CONSENT CLAUSE",
    paragraphs: [
      "The Client grants the Event Planner permission to photograph and/or video record elements of the event strictly for portfolio, website, social media, and marketing purposes.",
      "No personal or sensitive information will be shared without the Client's written consent.",
      "If the Client does not wish for event images to be used, written objection must be submitted prior to the event date.",
    ],
  },
  {
    title: "9. SCOPE CHANGE & PRICE ADJUSTMENT CLAUSE",
    paragraphs: [
      "Any changes requested by the Client after approval of the event plan, vendor bookings, or budget allocation may result in additional costs.",
      "The Event Planner reserves the right to revise quotations and service fees should the scope of work materially change.",
      "All additional costs must be approved in writing by the Client before implementation.",
    ],
  },
  {
    title: "10. LIMITATION OF LIABILITY (STRONGER PROTECTION)",
    paragraphs: [
      "The Event Planner acts solely as a coordinator and intermediary between the Client and third-party vendors.",
      "The Event Planner shall not be held liable for:",
    ],
    bullets: [
      "Vendor non-performance",
      "Vendor cancellations",
      "Service quality issues",
      "Delays",
      "Loss, theft, or damage",
      "Acts of force majeure",
      "Liability, if any, shall be limited to the total professional service fee paid to the Event Planner.",
    ],
  },
  {
    title: "11. POPIA (PROTECTION OF PERSONAL INFORMATION ACT) CLAUSE",
    paragraphs: ["Protection of Personal Information (POPIA)"],
    bullets: [
      "The Event Planner acknowledges its obligations in terms of the Protection of Personal Information Act 4 of 2013 (\"POPIA\").",
      "The Client consents to the Event Planner collecting, processing, storing, and using personal information for purposes directly related to event planning and coordination, vendor communication and bookings, invoicing and payment processing, and contract administration.",
      "Personal information may include full name, contact details, identification number (if required for venue or vendor access), and event-related details.",
      "The Event Planner undertakes to process personal information lawfully and transparently, implement reasonable technical and organisational safeguards, and not share personal information with third parties except where necessary for event execution or required by law.",
      "The Client has the right to request access to their personal information, request correction or deletion where applicable, and withdraw consent where legally permissible.",
      "By signing this Agreement, the Client confirms consent to the processing of personal information as outlined above.",
    ],
  },
  {
    title: "12. DISPUTE RESOLUTION CLAUSE",
    paragraphs: ["Dispute Resolution"],
    bullets: [
      "In the event of any dispute arising from this Agreement, the parties agree to first attempt to resolve the matter amicably through written communication and negotiation within fourteen (14) days of the dispute arising.",
      "Should the dispute remain unresolved after the negotiation period, the parties agree to refer the matter to mediation before instituting legal proceedings.",
      "Mediation shall take place in the province where the Event Planner's business is registered, and the costs of mediation shall be shared equally between the parties.",
      "Only if mediation fails may either party proceed with legal action in a court of competent jurisdiction within the Republic of South Africa.",
      "Nothing in this clause prevents either party from seeking urgent interim relief from a court where necessary.",
    ],
  },
];

export default function TermsAndConditions() {
  return (
    <main className="mx-auto w-full max-w-5xl px-6 py-16 text-[#212121]">
      <h1 className="mb-4 text-3xl font-semibold tracking-wide">Terms & Conditions</h1>
      <p className="mb-10 text-sm text-[#555]">
        The following clauses form part of the Event Planner's Terms and Conditions.
      </p>

      <div className="space-y-8">
        {sections.map((section) => (
          <section key={section.title} className="rounded-xl border border-[#e7e7e7] bg-white p-6 shadow-sm">
            <h2 className="mb-3 text-lg font-semibold">{section.title}</h2>

            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph} className="mb-3 text-sm leading-7 text-[#3a3a3a] last:mb-0">
                {paragraph}
              </p>
            ))}

            {section.bullets?.length ? (
              <ul className="mt-3 list-disc space-y-2 pl-5 text-sm leading-7 text-[#3a3a3a]">
                {section.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            ) : null}
          </section>
        ))}
      </div>
    </main>
  );
}
